import { ICategoryRequestApi } from '../types';
import { instance } from './instance';

const BASE = '/tenant-admin/category-request';

export const categoryRequestsApi: ICategoryRequestApi = {
  list: async ({ status, brandId, page, count } = {}) => {
    const params: Record<string, string | number> = {};
    if (status) params.status = status;
    if (brandId !== undefined) params.brandId = brandId;
    if (page !== undefined) params.page = page;
    if (count !== undefined) params.count = count;
    return await instance.get(BASE, { params });
  },

  getOne: async (id) => await instance.get(`${BASE}/${id}`),

  approve: async (id) => await instance.post(`${BASE}/${id}/approve`),

  decline: async (id, reason) =>
    await instance.post(`${BASE}/${id}/decline`, { reason }),
};
